import React from "react";
import Modal from "../../Components/Modal";

interface BotOption {
  id: string;
  name: string;
  fichas?: number;
}

const botOptions: BotOption[] = [
  { id: "1174", name: "Azul - Aeroportos", fichas: 19 },
  { id: "1096", name: "Azul - CargoExpress", fichas: 2 },
  { id: "996", name: "Azul - Céu", fichas: 2042 },
  { id: "1216", name: "Azul - Chat Unique", fichas: 13 },
  { id: "1185", name: "Azul - Concierge", fichas: 9 },
  { id: "1229", name: "Azul - Deixa que eu resolvo", fichas: 8 },
  { id: "1208", name: "Azul - Reacomodação", fichas: 20 },
  { id: "1217", name: "De Olho Na Experiência - Azul", fichas: 23 },
];

interface DevAuthModalProps {
  isOpen: boolean;
  botIdValue: string;
  onBotIdChange: (value: string) => void;
  onSubmit: (value: string) => Promise<void>;
  onClose: () => void;
  isLoading: boolean;
}

export const DevAuthModal: React.FC<DevAuthModalProps> = ({
  isOpen,
  botIdValue,
  onBotIdChange,
  onSubmit,
  onClose,
  isLoading,
}) => {
  const handleEntrar = () => {
    onSubmit(botIdValue);
  };

  const handleCancelar = () => {
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      question="Modo de Desenvolvimento - Informe o Bot ID"
      toggle={onClose}
      onButtonClick={(buttonId) => {
        if (buttonId === "Entrar") {
          handleEntrar();
        } else if (buttonId === "Cancelar") {
          handleCancelar();
        }
      }}
      modalRef={React.createRef()}
      buttonA="Cancelar"
      buttonB="Entrar"
      warning={false}
      text=""
      isSaveButtonDisabled={false}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "15px",
          padding: "10px",
          minWidth: "400px",
        }}
      >
        <p style={{ fontSize: "14px", color: "#666" }}>
          Você está em <strong>modo de desenvolvimento</strong>. Selecione o bot
          para acessar:
        </p>
        <select
          value={botIdValue}
          onChange={(e) => onBotIdChange(e.target.value)}
          style={{
            fontSize: "14px",
            border: "1px solid #ccc",
            borderRadius: "5px",
            outline: "none",
            backgroundColor: "#fff",
            cursor: "pointer",
            width: "100%",
            boxSizing: "border-box",
            color: "#333",
            fontWeight: "500",
          }}
          autoFocus
        >
          <option value="">Selecione um bot...</option>
          {botOptions.map((bot) => (
            <option key={bot.id} value={bot.id}>
              {bot.name} ({bot.fichas} fichas)
            </option>
          ))}
        </select>
        <p style={{ fontSize: "12px", color: "#999" }}>
          Dica: Você também pode adicionar ?bot_id=SEU_ID diretamente na URL
        </p>
      </div>
    </Modal>
  );
};
